"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const analytics_1 = require("@completeanatomy/analytics");
const ui_1 = require("@completeanatomy/ui");
const hotkeys_js_1 = __importDefault(require("hotkeys-js"));
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const AccountMenu_1 = __importDefault(require("../AccountMenu"));
// eslint-disable-next-line max-lines-per-function
function Logo(props) {
    const { className, onClickLogo } = props;
    const [isAccountMenuToolbarOpen, setIsAccountMenuToolbarOpen] = (0, react_1.useState)(false);
    const analytics = (0, analytics_1.useAnalytics)();
    const isTouchDevice = (0, ui_1.useIsTouchDevice)();
    const menuRef = (0, react_1.useRef)(null);
    const linkRef = (0, react_1.useRef)(null);
    const handleClick = (event) => {
        onClickLogo();
        event.preventDefault();
        analytics.log('top_left_logo_pressed', { name: 'top_left_logo' });
    };
    (0, react_1.useEffect)(() => {
        (0, hotkeys_js_1.default)('option+m, alt+m', event => {
            event.preventDefault();
            setIsAccountMenuToolbarOpen(true);
            event.stopPropagation();
        });
        (0, hotkeys_js_1.default)('command+option+m, ctrl+alt+m', event => {
            event.preventDefault();
            setIsAccountMenuToolbarOpen(false);
            event.stopPropagation();
        });
        return () => {
            hotkeys_js_1.default.unbind('option+m, alt+m');
            hotkeys_js_1.default.unbind('command+option+m, ctrl+alt+m');
        };
    }, []);
    (0, react_1.useEffect)(() => {
        setTimeout(() => {
            if (document.activeElement === linkRef.current) {
                document.activeElement.blur();
            }
        }, 0);
    }, []);
    const onFocus = () => {
        setIsAccountMenuToolbarOpen(true);
    };
    const onMouseEnter = () => {
        setIsAccountMenuToolbarOpen(true);
    };
    const onMouseLeave = () => {
        requestAnimationFrame(() => {
            var _a, _b;
            if (!((_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.contains(document.activeElement)) &&
                !((_b = linkRef.current) === null || _b === void 0 ? void 0 : _b.contains(document.activeElement))) {
                setIsAccountMenuToolbarOpen(false);
            }
        });
    };
    const onBlur = () => {
        requestAnimationFrame(() => {
            var _a, _b;
            if (!((_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.contains(document.activeElement)) &&
                !((_b = linkRef.current) === null || _b === void 0 ? void 0 : _b.contains(document.activeElement))) {
                setIsAccountMenuToolbarOpen(false);
            }
        });
    };
    (0, react_1.useEffect)(() => {
        if (!isAccountMenuToolbarOpen)
            return;
        const handleFocusChange = () => {
            var _a, _b;
            if (!((_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.contains(document.activeElement)) &&
                !((_b = linkRef.current) === null || _b === void 0 ? void 0 : _b.contains(document.activeElement))) {
                setIsAccountMenuToolbarOpen(false);
            }
        };
        document.addEventListener('focusin', handleFocusChange);
        return () => document.removeEventListener('focusin', handleFocusChange);
    }, [isAccountMenuToolbarOpen]);
    return ((0, jsx_runtime_1.jsx)(Wrapper, { onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, children: (0, jsx_runtime_1.jsx)(Link, { ref: linkRef, tooltip: {
                context: !isTouchDevice && ((0, jsx_runtime_1.jsx)(MenuWrapper, { ref: menuRef, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, children: (0, jsx_runtime_1.jsx)(AccountMenu_1.default, {}) })),
                place: 'bottom-end',
                isOpen: isAccountMenuToolbarOpen,
                opacity: 1,
                styles: {
                    backgroundColor: (0, ui_1.getTheme)().grasshopper.background,
                },
            }, className: className, onClick: handleClick, onFocus: onFocus, onBlur: onBlur, href: "#", children: (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: ui_1.Icons.Logo_Text, width: 60.61, height: 30 }) }) }));
}
const Wrapper = styled_components_1.default.div `
  position: relative;
  display: inline-block;
`;
const MenuWrapper = styled_components_1.default.div `
  top: 100%;
  right: 0;
`;
const Link = (0, ui_1.withTooltip)(styled_components_1.default.a `
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px;
  border-radius: 4px;

  &:hover {
    background-color: ${({ theme }) => theme.grasshopper.menuButtons.hoverBackground};
  }
  &:active {
    background-color: transparent;
  }

  box-sizing: border-box;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.designSystem.accent};
    outline-offset: 2px;
    border-radius: 1px;
  }
`);
exports.default = Logo;
